// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"Tabs_tabGroup__Gjl_y","tab":"Tabs_tab__XOGHJ","active":"Tabs_active__klO_W","iconOnly":"Tabs_iconOnly__fofgq","mobileButtons":"Tabs_mobileButtons__le5SY"};